import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddCompanyGroupForm from './AddCompanyGroupForm';

class AddCompanyGroupModal extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
  }

  handleSubmit = () => {
    if (this.formRef.current && typeof this.formRef.current.handleSubmit === 'function') {
      this.formRef.current.handleSubmit();
    } else {
      console.error('Form ref or handleSubmit is not correctly set');
    }
  };

  handleConfirm = () => {
    console.log('Form ref on confirm:', this.formRef.current);
    this.handleSubmit();
  };

  render() {
    const { isOpen, onConfirm, onCancel } = this.props;

    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>Add Company Group</ModalHeader>
        <ModalBody>
          <AddCompanyGroupForm
            ref={this.formRef}
            onConfirm={onConfirm}
          />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>Cancel</Button>
          <Button color="primary" onClick={this.handleConfirm} id="group-submit-btn">Submit</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddCompanyGroupModal;
